import {DynamicReportOutputType} from './jobs.types';

const INTERVAL_MS_DEFAULT = 2000;

const dynamicReportOutputTypeName: Record<DynamicReportOutputType, string> = {
  [DynamicReportOutputType.CSV]: 'csv',
  [DynamicReportOutputType.CSV_GZIPPED]: 'csv.gz',
  [DynamicReportOutputType.Excel]: 'xlsx',
  [DynamicReportOutputType.PARQUET]: 'parquet',
};

export {INTERVAL_MS_DEFAULT, dynamicReportOutputTypeName};
